module.exports = __webpack_public_path__ + "8b10f2d9e66fd2a3a28c11e7f86113e6.png";